import { createReducer, on } from '@ngrx/store';
import { LogoutDialogState } from './logout-dialog.state';
import { logoutDialogStateInitial } from './logout-dialog.state.initial';
import { LogoutDialogActions } from './logout-dialog.actions';

/**
 * Reducer für den Logout-Dialog.
 */
export const logoutDialogReducers = createReducer(
  logoutDialogStateInitial,

  on(
    LogoutDialogActions.open,
    (state): LogoutDialogState => ({
      ...state,
      isOpen: true,
    }),
  ),

  on(
    LogoutDialogActions.close,
    (state): LogoutDialogState => ({
      ...state,
      isOpen: false,
    }),
  ),

);
